import { ModelViewerElement } from "@google/model-viewer/dist/model-viewer";

class HuemenARPlayer extends ModelViewerElement {
  constructor() {
    super();
  }
}
window.customElements.define("huemen-ar-player", HuemenARPlayer);
export default HuemenARPlayer;
